import React from "react";
import {observer} from "mobx-react";
import {Button, Checkbox, Form, message, Radio, Switch, Upload} from "antd";
import styled from "styled-components";
import {UploadRequestOption as RcCustomRequestOptions} from "rc-upload/lib/interface";
import {RcFile} from "antd/es/upload";
import {
    uploadOriginalExcel,
    uploadAtlasExcel,
    uploadBaseLibraryExcel, uploadDnaExcel,
    uploadSpecimenExcelApi,
    uploadSpecimenPictureApi
} from "../../http/manager";
import Dragger from "antd/es/upload/Dragger";
import {InboxOutlined} from "@ant-design/icons";
import {showFullScreenLoading, tryHideFullScreenLoading} from "../../config/serviceLoading";
import {ExcelUploadType} from "../../common/Constant";
import {ResultData} from "../../http/interface";
import FormItem from "antd/es/form/FormItem";

const options = [
    {label: '数据', value: 'excel'},
    {label: '照片', value: 'photo'},
];

interface UploadFileProps {
    id?: string;
    onSuccess?: () => void;
    funType: number;
}

const UploadFile: React.FC<UploadFileProps> = ({id, onSuccess, funType}) => {

    let isNeedWatermark = 1;

    const uploadFile = (options: RcCustomRequestOptions) => {
        // 判断文件类型
        const {file} = options;
        const uploadFile = file as RcFile;
        if (uploadFile) {
            const {type, name} = uploadFile;
            const fileType = name.substring(name.lastIndexOf("."))
            const params = new FormData();
            showFullScreenLoading()
            if (".xls" === fileType || ".xlsx" === fileType) {
                params.append("file", file);
                getUploadActionByType(params)
                    .then((res) => {
                        tryHideFullScreenLoading()
                        if (Number(res.code) === 200) {
                            message.success("文件上传成功")
                            if (onSuccess) {
                                onSuccess();
                            }
                        } else {
                            message.error("文件上传失败");
                        }
                    })
                    .catch((e) => {
                        tryHideFullScreenLoading()
                        message.error("文件上传失败");
                    })
            } else if (type === 'image/jpeg' || type === 'image/png' || fileType === '.zip') {
                if (id) {
                    params.append("id", id);
                }
                params.append("file", file);
                params.append("type", funType + "")
                params.append("watermark", isNeedWatermark+"")
                uploadSpecimenPictureApi(params)
                    .then((res) => {
                        tryHideFullScreenLoading()
                        if (Number(res.code) === 200) {
                            message.success("图片上传成功")
                            if (onSuccess) {
                                onSuccess();
                            }
                        } else {
                            message.error("图片上传失败");
                        }
                    })
                    .catch((e) => {
                        tryHideFullScreenLoading()
                        message.error("图片上传失败");
                    })
            } else {
                tryHideFullScreenLoading()
                message.error("不支持的文件类型");
            }
        } else {
            message.error("不支持的文件类型");
        }
    }

    const getUploadActionByType = (params: any) => {
        const resultData: ResultData = {
            message: "1",
            code: "1",
        }
        switch (funType) {
            case ExcelUploadType.BASIC:
                return uploadBaseLibraryExcel(params);
            case ExcelUploadType.SPECIMEN:
                return uploadSpecimenExcelApi(params);
            case ExcelUploadType.ORIGINAL:
                return uploadOriginalExcel(params);
                // return new Promise((resolve, reject) => {
                //     resolve({code: "1", message: "1"} as ResultData)
                // })
            case ExcelUploadType.ATLAS:
                return uploadAtlasExcel(params)
            case ExcelUploadType.DNA:
                return uploadDnaExcel(params)
            default:
                return Promise.resolve(resultData)
        }
    }

    return (
        <Wrapper>
            {/*<span>文件类型：</span>*/}
            {/*<Radio.Group*/}
            {/*    style={{marginBottom:"20px"}}*/}
            {/*    options={options}*/}
            {/*    optionType="button"*/}
            {/*    buttonStyle="solid"/>*/}
            <TitleSpan>批量上传</TitleSpan>
            <TipsSpan>{funType === ExcelUploadType.BASIC ? "支持文件类型（.xls、.xlsx）" : "支持的文件类型（.xls、.xlsx、.jpeg、.png、 .zip）"}</TipsSpan>
            <Form>
                <FormItem label={"是否开启水印"}>
                    <Switch checkedChildren="开启" unCheckedChildren="关闭" defaultChecked={true}
                            onChange={(checked) => checked ? isNeedWatermark = 1 : isNeedWatermark = 0}/>
                </FormItem>
            </Form>
            <Dragger maxCount={1}
                     customRequest={(options) => {
                         uploadFile(options)
                     }}
                     showUploadList={false}>
                <p className="ant-upload-drag-icon">
                    <InboxOutlined/>
                </p>
                <p className="ant-upload-text">单击或拖动文件到此区域上传</p>
            </Dragger>

        </Wrapper>);
}

export default observer(UploadFile);

const Wrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    padding: 10px 15px 15px 15px;
  }
`;
const TitleSpan = styled.span`
{
  font-size: 16px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #000000;
  line-height: 24px;
  margin-bottom: 5px;
}
`;
const TipsSpan = styled.span`
  & {
    font-size: 14px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    color: #ff0000;
    margin-bottom: 20px;
    line-height: 24px;

  }
`;